module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (151).4828f95c.jpg";